<div class="upload-action-items">
    <img src="../../../assets//images/documents/icon-upload-document.svg" class="icon-download" [alt]="fileDesc" (click)="downloadDocument()"
    > 
   <!-- </div> -->
</div>

<!-- #tooltip="matTooltip" matTooltip="Download" matTooltipPosition="above" -->